export default "__VITE_ASSET__NyvdALvd__"